"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _merchant = require("@/api/merchant");
var _order = require("@/api/order");
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _auth = require("@/utils/auth.js");
var _default = {
  components: {
    customPage: _customPage.default
  },
  data: function data() {
    return {
      loading: false,
      pickDate: null,
      searchForm: {
        date: '',
        merchantId: ''
      },
      total: 0,
      tableData: [],
      merchantList: [{
        id: 0,
        username: '请选择'
      }]
    };
  },
  watch: {
    pickDate: function pickDate(val) {
      if (val) {
        this.searchForm.date = val.join('~');
      } else {
        this.searchForm.date = '';
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    // this.getDistributionMerchantList()
    this.setPickDate();
    this.$nextTick(function () {
      _this.getList();
    });
  },
  methods: {
    setPickDate: function setPickDate() {
      var today = this.$func.dateFormat('yyyy-mm-dd');
      this.pickDate = [today + ' 00:00:00', today + ' 23:59:59'];
    },
    // 获取接单商户列表
    getDistributionMerchantList: function () {
      var _getDistributionMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, _this$merchantList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getDistributionMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  (_this$merchantList = this.merchantList).push.apply(_this$merchantList, (0, _toConsumableArray2.default)(res.data));
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getDistributionMerchantList() {
        return _getDistributionMerchantList2.apply(this, arguments);
      }
      return getDistributionMerchantList;
    }(),
    getList: function getList() {
      var _this2 = this;
      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // flag为true, 则不刷新表格
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      if (!flag) {
        this.tableData = [];
      }
      this.loading = true;
      this.loading = true;
      var merchanID = (0, _auth.getMerchantId)();
      this.searchForm.merchantId = merchanID;
      console.log('商户ID', merchanID);
      (0, _order.getTradingCountList)((0, _objectSpread2.default)({}, this.searchForm)).then(function (res) {
        _this2.loading = false;
        _this2.tableData = res || [];
        _this2.loading = false;
      });
    },
    // 查询
    search: function search() {
      this.$refs.customPage.page = 1;
      this.getList();
    },
    // 重置
    reset: function reset() {
      this.searchForm = this.$options.data().searchForm;
      this.setPickDate();
      this.getList();
    }
  }
};
exports.default = _default;